import React, { useState, useContext, useEffect } from "react";
import { Formik } from "formik";
import { Table, Empty, Button, Select } from "antd";

import * as Yup from "yup";
import ErrorMessage from "../components/ErrorMessage";

import authClient from "../api/authClient";
import AuthContext from "../auth/context";

import locale from "antd/es/date-picker/locale/fr_FR";

import DatePicker from "../components/DatePicker";

import format from "dayjs";

import "dayjs/locale/fr";

import "antd/dist/antd.css";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const { Option } = Select;

const zoneDetailSalarie = (record) => (
  <>
    <div className="row mb-2">
      <div className="col">
        {record.details !== undefined &&
          record.details.map((d) => (
            <div key={d.id} className="row">
              <div className="col">
                <div className="row">
                  <div className="col">
                    Date réception pointage :{" "}
                    <b>
                      {format(d.localDateCreation).format(
                        "HH:mm, le DD/MM/YYYY"
                      )}{" "}
                    </b>
                  </div>
                  {d.localDebut && (
                    <>
                      <div className="col">
                        Pointage début :{" "}
                        <b>
                          {format(d.localDebut).format("HH:mm, le DD/MM/YYYY")}{" "}
                        </b>
                      </div>
                      <div className="col">
                        Pointage début manuel :{" "}
                        {d.pointageDebutManuel ? (
                          <span className={"badge badge-danger-lighten p-1"}>
                            OUI
                          </span>
                        ) : (
                          <span className={"badge badge-success-lighten p-1"}>
                            NON
                          </span>
                        )}
                      </div>
                    </>
                  )}

                  {d.localFin && (
                    <>
                      <div className="col">
                        Pointage fin :{" "}
                        <b>
                          {format(d.localFin).format("HH:mm, le DD/MM/YYYY")}{" "}
                        </b>
                      </div>
                      <div className="col">
                        Pointage fin manuel :{" "}
                        {d.pointageFinManuel ? (
                          <span className={"badge badge-danger-lighten p-1"}>
                            OUI
                          </span>
                        ) : (
                          <span className={"badge badge-success-lighten p-1"}>
                            NON
                          </span>
                        )}
                      </div>
                    </>
                  )}

                  <div className="col">
                    Transmis :{" "}
                    {d.pushed ? (
                      <span className={"badge badge-success-lighten p-1"}>
                        OUI
                      </span>
                    ) : (
                      <span className={"badge badge-danger-lighten p-1"}>
                        NON
                      </span>
                    )}
                  </div>
                </div>
              </div>
            </div>
          ))}
      </div>
    </div>
  </>
);

const columns = [
  {
    title: "Identifiant d'origine",
    dataIndex: "idOrigine",
    key: "idOrigine",
  },
  {
    title: "Date dernière MAJ.",
    dataIndex: "localDateDerniereMaj",
    key: "localDateDerniereMaj",
    render: (text, record) =>
      format(record.localDateDerniereMaj).format("DD/MM/YYYY HH:mm:ss"),
  },
  {
    title: "Salarie",
    dataIndex: "localSalarie",
    key: "localSalarie",
    render: (text, record) =>
      record.localSalarie.nom +
      " " +
      (record.localSalarie.prenom ? record.localSalarie.prenom : ""),
  },
  {
    title: "Client",
    dataIndex: "localClient",
    key: "localClient",
    render: (text, record) =>
      record.localClient.nomClient +
      " " +
      (record.localClient.prenomClient ? record.localClient.prenomClient : ""),
  },
  {
    title: "Prestation",
    dataIndex: "localPrestation",
    key: "localPrestation",
  },
  {
    title: "Date début",
    dataIndex: "localDateDebut",
    key: "localDateDebut",
    render: (text, record) =>
      format(record.localDateDebut).format("DD/MM/YYYY HH:mm:ss"),
  },
  {
    title: "Date fin",
    dataIndex: "localDateFin",
    key: "localDateFin",
    render: (text, record) =>
      format(record.localDateFin).format("DD/MM/YYYY HH:mm:ss"),
  },
  {
    title: "Pointage Début",
    dataIndex: "localPointageDebut",
    key: "localPointageDebut",
    render: (text, record) =>
      record.localPointageDebut
        ? format(record.localPointageDebut).format("DD/MM/YYYY HH:mm:ss")
        : "",
  },
  {
    title: "Pointage Fin",
    dataIndex: "localPointageFin",
    key: "localPointageFin",
    render: (text, record) =>
      record.localPointageFin
        ? format(record.localPointageFin).format("DD/MM/YYYY HH:mm:ss")
        : "",
  },
];

const validationSchema = Yup.object().shape({
  societe: Yup.string().required("La société est obligatoire"),
  dateDebut: Yup.date("La date de début est incorrecte").required(
    "La date de début est obligatoire"
  ),
  dateFin: Yup.date("La date de fin est incorrecte")
    .required("La date de fin est obligatoire")
    .when(
      "dateDebut",
      (dateDebut, schema) =>
        dateDebut && schema.min(dateDebut, "Les dates sont incohérentes")
    ),
});

const Missions = () => {
  const [loading, setLoading] = useState(false);
  const [initDone, setInitDone] = useState(false);
  const [listeSocietes, setListeSocietes] = useState([]);
  const [listeSalaries, setListeSalaries] = useState([]);

  const authContext = useContext(AuthContext);

  useEffect(() => {
    initListes();
  }, []);

  const initListes = async () => {
    setLoading(true);

    const retour = await authClient.getSocietes();

    setLoading(false);

    if (!retour.ok) {
      if (retour.status === 401 || retour.status === 403) {
        localStorage.removeItem("currentUser");
        authContext.setUser(null);
      } else {
        toast.error("Une erreur inattendue est survenue");
      }
    } else {
      if (retour.data) {
        setListeSocietes(retour.data);
      } else {
        setListeSocietes(undefined);
      }

      setInitDone(true);
    }
  };

  const handlePlusInfo = async (expanded, record) => {
    if (!expanded) return;

    if (record.details) return;

    setLoading(true);

    const retour = await authClient.moreInfoMission(
      record.idSociete,
      record.id
    );

    console.log("retour détail mission", retour);

    setLoading(false);

    if (!retour.ok) {
      if (retour.status === 401 || retour.status === 403) {
        localStorage.removeItem("currentUser");
        authContext.setUser(null);
      } else {
        toast.error("Une erreur inatendue est survenue");
      }
    } else {
      record.details = retour.data;

      const nouvelleListe = [...listeSalaries];

      nouvelleListe.forEach((k) => {
        if (k.id === record.id) {
          k = record;
        }
      });

      setListeSalaries(nouvelleListe);

      //lancerRecherche();
      // Confirmer l'action
      // toast.success("Le kleaner a été invalidé avec succès");
    }
  };

  const lancerRecherche = async (values) => {
    setLoading(true);

    const toSend = {
      ...values,
      dateDebut: values.dateDebut.format("YYYY-MM-DD"),
      dateFin: values.dateFin.format("YYYY-MM-DD"),
    };

    const retour = await authClient.getMissions(toSend);

    setLoading(false);

    if (!retour.ok) {
      if (retour.status === 401 || retour.status === 403) {
        localStorage.removeItem("currentUser");
        authContext.setUser(null);
      } else {
        toast.error("Une erreur inattendue est survenue");
      }
    } else {
      if (retour.data) {
        console.log(retour.data);
        setListeSalaries(retour.data);
      } else {
        setListeSalaries(undefined);
      }
    }
  };

  if (!initDone)
    return (
      <>
        <ToastContainer />
      </>
    );

  return (
    <>
      <ToastContainer />
      <div
        className="modal fade"
        id="userModal"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">
                Détails du salarié
              </h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>

            <div className="modal-body">
              <div className="form-group mb-1">
                <label htmlFor="loginUser">Identifiant</label>
              </div>
              <div className="form-group mb-1">
                <label htmlFor="nomUser">Nom</label>
              </div>
              <div className="form-group mb-1">
                <label htmlFor="prenomUser">Prénom</label>
              </div>
              <div className="form-group mb-1">
                <label htmlFor="emailUser">Email</label>
              </div>
            </div>
            <div className="modal-footer">
              <Button
                loading={loading}
                className="btn btn-secondary"
                type="primary"
                data-dismiss="modal"
              >
                Fermer
              </Button>
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-12">
          <div className="page-title-box">
            <h4 className="page-title">Missions</h4>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col">
          <div className="card mb-4">
            <div className="card-header">Critères de recherche</div>
            <div className="card-body">
              <Formik
                validationSchema={validationSchema}
                initialValues={{
                  societe: "",
                  nomSalarie: "",
                  prenomSalarie: "",
                  imei: "",
                  nomClient: "",
                  prenomClient: "",
                  dateDebut: format().startOf("month"),
                  dateFin: format().endOf("month"),
                }}
                onSubmit={(values) => {
                  lancerRecherche(values);
                }}
              >
                {({
                  handleChange,
                  handleSubmit,
                  errors,
                  setFieldTouched,
                  touched,
                  setFieldValue,
                  setErrors,
                  values,
                }) => (
                  <>
                    <div className="form-row">
                      <div className="col-md-4">
                        <div className="form-group">
                          <label htmlFor="societe">Société :</label>
                          <Select
                            showSearch
                            filterOption={(input, option) =>
                              option.children
                                .toLowerCase()
                                .indexOf(input.toLowerCase()) >= 0
                            }
                            id="societe"
                            value={values["societe"]}
                            onChange={handleChange("societe")}
                            className="form-control"
                          >
                            <Option value="">
                              Veuillez sélectionner une société
                            </Option>
                            {listeSocietes.map((s) => (
                              <Option
                                key={s.idSociete}
                                value={s.idSociete.toString()}
                              >
                                {s.nomSociete}
                              </Option>
                            ))}
                          </Select>
                          <ErrorMessage
                            error={errors.societe}
                            visible={touched.societe}
                          />
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="form-group">
                          <label htmlFor="nom">Date début :</label>
                          <DatePicker
                            showToday
                            className="form-control"
                            locale={locale}
                            utc
                            value={
                              values["dateDebut"] ? values["dateDebut"] : null
                            }
                            format="DD/MM/YYYY"
                            onChange={(date, dateString) => {
                              console.log("date", date);
                              console.log("dateString", dateString);
                              if (date) {
                                setFieldValue("dateDebut", date);
                              } else {
                                setFieldValue("dateDebut", undefined);
                              }
                            }}
                          />
                          <ErrorMessage
                            error={errors.dateDebut}
                            visible={errors.dateDebut}
                          />
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="form-group">
                          <label htmlFor="nom">Date fin :</label>
                          <DatePicker
                            showToday
                            className="form-control"
                            locale={locale}
                            value={
                              values["dateFin"]
                                ? format(values["dateFin"])
                                : null
                            }
                            format="DD/MM/YYYY"
                            onChange={(date, dateString) => {
                              if (date) {
                                setFieldValue("dateFin", date);
                              } else {
                                setFieldValue("dateFin", undefined);
                              }
                            }}
                          />
                          <ErrorMessage
                            error={errors.dateFin}
                            visible={errors.dateFin}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="form-row">
                      <div className="col-md-4">
                        <div className="form-group">
                          <label htmlFor="nomSalarie">Nom Salarié :</label>
                          <input
                            value={values["nomSalarie"]}
                            onChange={handleChange("nomSalarie")}
                            className="form-control"
                            id="nomSalarie"
                            type="text"
                          />
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="form-group">
                          <label htmlFor="prenomSalarie">
                            Prénom Salarié :
                          </label>
                          <input
                            value={values["prenomSalarie"]}
                            onChange={handleChange("prenomSalarie")}
                            className="form-control "
                            id="prenomSalarie"
                            type="text"
                          />
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="form-group">
                          <label htmlFor="imei">IMEI :</label>
                          <input
                            value={values["imei"]}
                            onChange={handleChange("imei")}
                            className="form-control "
                            id="imei"
                            type="text"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="form-row">
                      <div className="col-md-4">
                        <div className="form-group">
                          <label htmlFor="nomClient">Nom Client :</label>
                          <input
                            value={values["nomClient"]}
                            onChange={handleChange("nomClient")}
                            className="form-control"
                            id="nomClient"
                            type="text"
                          />
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="form-group">
                          <label htmlFor="prenomClient">Prénom Client :</label>
                          <input
                            value={values["prenomClient"]}
                            onChange={handleChange("prenomClient")}
                            className="form-control "
                            id="prenomClient"
                            type="text"
                          />
                        </div>
                      </div>
                    </div>

                    <div className="form-group d-flex align-items-center justify-content-end mt-2 mb-0 ">
                      <Button
                        loading={loading}
                        className="btn btn-primary"
                        type="primary"
                        onClick={handleSubmit}
                      >
                        Rechercher
                      </Button>
                    </div>
                  </>
                )}
              </Formik>
            </div>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col">
          <div className="card mb-4">
            <div className="card-header">Liste des Missions</div>
            <div className="card-body">
              <div className="table-responsive">
                <Table
                  rowKey="id"
                  loading={loading}
                  columns={columns}
                  dataSource={listeSalaries}
                  expandable={{
                    expandedRowRender: (record) => zoneDetailSalarie(record),
                    onExpand: (expanded, record) =>
                      handlePlusInfo(expanded, record),
                  }}
                  locale={{
                    sortTitle: "trier",
                    cancelSort: "Cliquez pour annuler le tri",
                    triggerAsc: "Cliquez pour un tri ascendant",
                    triggerDesc: "Cliquez pour un tri descendant",
                    emptyText: (
                      <Empty
                        image="https://gw.alipayobjects.com/zos/antfincdn/ZHrcdLPrvN/empty.svg"
                        imageStyle={{
                          height: 60,
                        }}
                        description={<span>Aucune Mission</span>}
                      ></Empty>
                    ),
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Missions;
